import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-menu-layout" }
const _hoisted_2 = { class: "menu-ul" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNavList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.value,
          onClick: ($event: any) => (_ctx.addPageItem(item.value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["font_family", _ctx.setPageNavIcon(item.value)])
          }, null, 2),
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.label), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}